<template>
	<div name="hress5u-popup2" id="hress5u-popup2" class="modal fade" role="dialog">
		<div class="modal-dialog modal-lg">
	    <div class="modal-content">
	      <div class="modal-header header-popup">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">{{ labels['HRESS5UP1']['0'] }}</h4>
        </div>

        <div class="modal-body detail detail-responsive">
        	
					<div class="clearfix detail-row">
						<div class="detail-left label-left">{{ labels['HRESS5UP1']['20'] }}</div>
						<div class="detail-right">
						    <div class="detail-text width-100" id="coddesc_codjob" name="coddesc_codjob">{{ popup2DetailTab2.tab1.codjob }} - {{ popup2DetailTab2.tab1.desc_codjob }}</div>
						</div>
					</div>
					
					<div id="accordion-tab2Popup2">  
						<!-- Tab 1 -->
	          <div class="panel box-collapse border-color-skin">
			        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion-tab2Popup2" href="#detailsPopup2Tab1">
			          <h3 class="box-title">
			            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UP1']['0'] }}
			          </h3>
			        </div>
			        <div id="detailsPopup2Tab1" class="panel-collapse collapse in tab-detail">
			          <div class="panel-body">

			          	<div class="detail-block">						
								    <div class="clearfix detail-row">
							        <div class="detail-left label-left">{{ labels['HRESS5UP1']['40'] }}</div>
							        <div class="detail-right">
							           <div class="detail-text txtarea-width width-100" id="desc_codjob" name="desc_codjob">{{ popup2DetailTab2.tab1.desc_codjob }}</div>
							        </div>
								    </div>

								    <div class="clearfix detail-row">
							        <div class="detail-left label-left">{{ labels['HRESS5UP1']['50'] }}</div>
							        <div class="detail-right">
							            <div class="detail-text txtarea-width width-100" id="desjob" name="desjob">{{ popup2DetailTab2.tab1.desjob }}</div>
							        </div>
								    </div>
									</div>

									<div class="detail-block-float detail-block-left">
								    <div class="clearfix detail-row">
								       <div class="detail-header">{{ labels['HRESS5UP1']['60'] }}</div>
								    </div>
									
								    <div class="clearfix detail-row">
							        <div class="detail-left label-left">{{ labels['HRESS5UP1']['70'] }}</div>
							        <div class="detail-right">
						            <div class="input-group">
						            	<input type="text" disabled="disabled" class="form-control input-text" id="amtcolla" name="amtcolla" v-model="popup2DetailTab2.tab1.amtcolla" >
						              <div class="input-group-addon input-group-addon-cust">{{ labels['HRESS5UP1']['80'] }}</div>
						            </div>
							        </div>
								    </div>
									
								    <div class="clearfix detail-row">
							        <div class="detail-left label-left">{{ labels['HRESS5UP1']['90'] }}</div>
							        <div class="detail-right">
						            <div class="input-group">
						            	<input type="text" disabled="disabled" class="form-control input-text" id="qtyguar" name="qtyguar" v-model="popup2DetailTab2.tab1.qtyguar" >
					                <div class="input-group-addon input-group-addon-cust">{{ labels['HRESS5UP1']['100'] }}</div>
						            </div>
							        </div>
								    </div>
									
								    <div class="clearfix detail-row">
							        <div class="detail-left label-left">{{ labels['HRESS5UP1']['110'] }}</div>
							        <div class="detail-right">
						            <div class="input-group">
						            	<input type="text" disabled="disabled" class="form-control input-text" id="qtyyrsur" name="qtyyrsur" v-model="popup2DetailTab2.tab1.qtyyrsur" >
					                <div class="input-group-addon input-group-addon-cust">{{ labels['HRESS5UP1']['120'] }}</div>
						            </div>
							        </div>
								    </div>
									</div>		

									<div class="detail-block-float detail-block-right">
								    <div class="clearfix detail-row">
								        <div class="detail-left label-left">{{ labels['HRESS5UP1']['130'] }}</div>
								        <div class="detail-right">
								            <div class="detail-text txtarea-width width-100" id="syncond" name="syncond">{{ popup2DetailTab2.tab1.syncond }}</div>
								        </div>
								    </div>
									</div>	     

			          </div>
			        </div>
		        </div>		
		        <!-- Tab 2 -->
	          <div class="panel box-collapse border-color-skin">
			        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion-tab2Popup2" href="#detailsPopup2Tab2">
			          <h3 class="box-title">
			            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UP2']['0'] }}
			          </h3>
			        </div>
			        <div id="detailsPopup2Tab2" class="panel-collapse collapse tab-detail">
			          <div class="panel-body">
			          	<hrms-table :columns="columnsDetailTab2Popup2Tab2" :data="popup2DetailTab2.tab2.table" />	          		    
			          </div>
			        </div>
		        </div>
		        <!-- Tab 3 -->
	          <div class="panel box-collapse border-color-skin">
			        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion-tab2Popup2" href="#detailsPopup2Tab3">
			          <h3 class="box-title">
			            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UP3']['0'] }}
			          </h3>
			        </div>
			        <div id="detailsPopup2Tab3" class="panel-collapse collapse tab-detail">
			          <div class="panel-body">
					        <hrms-table :columns="columnsDetailTab2Popup2Tab3" :data="popup2DetailTab2.tab3.table" />	  
			          </div>
			        </div>
		        </div>		
		        <!-- Tab 4 -->
	          <div class="panel box-collapse border-color-skin">
			        <div class="box-header with-border box-header-collapse collapsed tab-header" data-toggle="collapse" data-parent="#accordion-tab2Popup2" href="#detailsPopup2Tab4">
			          <h3 class="box-title">
			            <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRESS5UP5']['0'] }}
			          </h3>
			        </div>
			        <div id="detailsPopup2Tab4" class="panel-collapse collapse tab-detail">
			          <div class="panel-body">
			          	<hrms-table :columns="columnsDetailTab2Popup2Tab4" :data="popup2DetailTab2.tab4.table" />	
			          </div>
			        </div>
		        </div>

        	</div>		
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hress5u-popup2',
  props: [ 'labels', 'popup2DetailTab2', 'columnsDetailTab2Popup2Tab2', 'columnsDetailTab2Popup2Tab3', 'columnsDetailTab2Popup2Tab4' ]
}
</script>





// WEBPACK FOOTER //
// popup2.vue?21328bee